import React from 'react';
import AdvisorsList, { advisorsListThemes } from '../../../advisors_list';
import {
  advisorsSectionThemes, sectionIds
} from '../../prop_types';
import AdvisorSectionTitle from '../advisors_section/advisor_section_title';
import { isKA } from '../../../../../common/config/utils';

function AllAdvisorsSection({
  title,
  loading,
  iconUrl,
  showMore,
  slug,
  content,
  analytics,
  params,
  loadHomePage,
  allAdvisorsListSection = {},
  index
}) {
  const renderTitle = () => (
    <AdvisorSectionTitle
      title={ title }
      loading={ loading }
      iconUrl={ iconUrl }
      showMore={ showMore }
      slug={ slug }
      theme={ advisorsSectionThemes.all_advisors_section }
      params={ params }
    />
  );

  const loadAdvisorsForHomePageAllAdvisors = (param) => {
    loadHomePage(false, { section_ids: [sectionIds.allAdvisorsList].join(), ...param });
  };

  const renderAdvisorsList = () => (
    <AdvisorsList
      advisors={ content.advisors }
      theme={ advisorsListThemes.homePageAllAdvisors }
      loading={ loading }
      analytics={ analytics }
      slug={ slug }
      params={ params }
      loadAdvisors={ isKA() ? loadAdvisorsForHomePageAllAdvisors : undefined }
      page={ isKA() ? allAdvisorsListSection.page : undefined }
      lastPageNum={ isKA() ? allAdvisorsListSection.lastPageNum || 2 : undefined }
      sectionIndex={ index }
    />
  );

  const renderContent = () => {
    if (!(content || {}).advisors) return null;
    return (
      <div style={ { width: '100%' } } suppressHydrationWarning data-testid="HP-all-advisors-section">
        { renderTitle() }
        {renderAdvisorsList() }
      </div>
    );
  };

  return renderContent();
}

export default AllAdvisorsSection;
